module.exports = __webpack_public_path__ + "static/media/framework.404e9a94.png";